<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div class="file-preview-container">
  <ng-container *ngIf="fileToView">
    <div class="preview-header">
      <p i18n>Preview (showing the first {{numRowsToPreview}} rows)</p>
      <button *ngIf="isChartEnable" mat-icon-button (click)="showChart()">
        <mat-icon>insert_chart</mat-icon>
      </button>
    </div>
    <table mat-table [dataSource]="dataSource.slice(0, numRowsToPreview)" class="mat-elevation-z8">
        <!-- Column Definitions -->
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef>{{ column | titlecase }}</th>
            <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </ng-container>
        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>
</div>